import { handleImgSize } from '@/common/utils/map_view_data'
export default {
    methods: {
        getCoverPhoto: function (url) {
            return handleImgSize(url, 320, 320)
        },
        getPhoto: function (photos_urls, url) {
            return photos_urls.length === 1 ? handleImgSize(url, 500) : handleImgSize(url, 300, 300)
        }
    }
}